"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const arrows_svg_1 = __importDefault(require("../assets/images/arrows.svg"));
const styles_1 = require("@mui/styles");
const style_util_1 = require("../@common/util/style-util");
const i18n_util_1 = require("../@common/util/i18n-util");
const t = key => i18n_util_1.translate('lwt-lib-a11ySettings', key);
const LoadingScreen = ({ backgroundImage, loadingImage }) => {
    var _a, _b, _c, _d;
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.loadingContainer },
        react_1.default.createElement("img", { src: (_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) !== null && _a !== void 0 ? _a : i18n_util_1.getTranslatedImage('notepad.svg'), className: classes.backgroundImage, alt: `${(_b = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.alt) !== null && _b !== void 0 ? _b : t('notepadIcon')}` }),
        react_1.default.createElement("img", { src: (_c = loadingImage === null || loadingImage === void 0 ? void 0 : loadingImage.src) !== null && _c !== void 0 ? _c : arrows_svg_1.default, className: `${classes.loadingImage} ${classes.animatedItem}`, alt: `${(_d = loadingImage === null || loadingImage === void 0 ? void 0 : loadingImage.alt) !== null && _d !== void 0 ? _d : t('spinnerIcon')}` })));
};
const useStyles = styles_1.makeStyles(() => ({
    '@keyframes spin': {
        '0%': {
            transform: 'rotate(360deg)'
        },
        '100%': {
            transform: 'rotate(0deg)'
        }
    },
    animatedItem: {
        animation: `$spin 2s infinite`
    },
    backgroundImage: {
        marginLeft: style_util_1.remCalc(-48),
        width: style_util_1.remCalc(150)
    },
    loadingContainer: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        left: '0',
        position: 'fixed',
        top: '0',
        userSelect: 'none',
        width: '100%',
        zIndex: 8
    },
    loadingImage: {
        marginLeft: style_util_1.remCalc(-96),
        width: style_util_1.remCalc(50)
    }
}));
exports.default = LoadingScreen;
